{
  "completed": "완료됨: ",
  "current": "현재: ",
  "notCompleted": "완료되지 않음: ",
  "steplist": "단계 목록"
}
